import React, { useContext } from "react";

export const WizardSummaryContext = React.createContext<{ summary: { value: any, label: any }[]; updateSummary: (accessor: string, newDisplayValue: string) => void; }>({ summary: new Array(0), updateSummary: () => { } });

export const useWizardSummaryContext = () => {
    return useContext(WizardSummaryContext);
};
